import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { CrmSettingsContainer } from '@/containers/integrations/settings/crm-settings-container.component';
import type { CrmUserRouteCrm } from '@/store/features/crm.feature';
import { createFileRoute, redirect } from '@tanstack/react-router';

// Attio opens its users panel only; it has no settings tabs.
const HEADINGS: Record<CrmUserRouteCrm, string> = {
  salesforce: 'Salesforce settings',
  hubspot: 'HubSpot settings',
  attio: 'Attio users',
};

const isValidCrm = (s: string): s is CrmUserRouteCrm =>
  Object.prototype.hasOwnProperty.call(HEADINGS, s);

export const Route = createFileRoute('/integrations/$crmType/settings')({
  validateSearch: (search: Record<string, unknown>): { tab?: 'users' } =>
    search.tab === 'users' ? { tab: 'users' } : {},
  beforeLoad: ({ params }) => {
    if (!isValidCrm(params.crmType)) {
      throw redirect({ to: '/integrations' });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { crmType } = Route.useParams();
  const { tab } = Route.useSearch();

  if (!isValidCrm(crmType)) return null;

  // CRM settings manage the org's OWN connection and are org-scoped on the
  // backend, so any authenticated org member may use them — no admin gate.
  // (Previously an AdminGate redirected non-admins, but the org:admin role was
  // never populated in the JWT, so it locked every customer out.)
  return (
    <>
      <Head heading={HEADINGS[crmType]} />
      <AuthCheck>
        <CrmSettingsContainer crmType={crmType} initialTab={tab} />
      </AuthCheck>
    </>
  );
}
